import _ from "lodash";

/**
 * Compara e retorna as diferenças entre dois objetos, recursivamente (deep).
 * Fonte: https://gist.github.com/Yimiprod/7ee176597fef230d1451
 *
 *
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export function deepDiff(object, base) {
    function changes(object, base) {
        return _.transform(object, function (result, value, key) {
            if (!_.isEqual(value, base[key])) {
                result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
            }
        });
    }
    return changes(object, base);
}

/**
 * Compara e retorna as diferenças entre dois objetos, superficialmente
 * (apenas no primeiro nível).
 */
export function shallowDiff(object, base) {
    return _.transform(object, function (result, value, key) {
        if (!_.isEqual(value, base[key])) {
            result[key] = value;
        }
    });
}
